import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import Erfassung from '@/views/Erfassung'
import Bewertung from '@/views/Bewertung'
import Aufwertung from '@/views/Aufwertung'
import Anonymisierung from '@/views/Anonymisierung'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        requiresAuth: true
      }
    },
    {
      path: '/erfassung/:id?',
      name: 'Erfassung',
      component: Erfassung,
      meta: {
        title: 'Erfassung',
        requiresAuth: true
      }
    },
    {
      path: '/bewertung/:id?',
      name: 'Bewertung',
      component: Bewertung,
      meta: {
        title: 'Bewertung',
        requiresAuth: true
      }
    },
    {
      path: '/aufwertung/:id?',
      name: 'Aufwertung',
      component: Aufwertung,
      meta: {
        title: 'Aufwertung',
        requiresAuth: true
      }
    },
    {
      path: '/anonymisierung/:id?',
      name: 'Anonymisierung',
      component: Anonymisierung,
      meta: {
        title: 'Anonymisierung',
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/sign-out',
      redirect: '/login'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js